import createInstance from "./instance";
import operation from "./v2/operation";
import operationId from "./v2/operation/[operationId]";
import corteva_user from "./v2/operation/[operationId]/corteva_user";
import user from "./v2/operation/[operationId]/user";
import userId from "./v2/operation/[operationId]/user/[userId]";
import setting from "./v2/operation/[operationId]/setting";
// v4
import operationV4 from "./v4/operations/[operationId]";
import operationsV4 from "./v4/operations/operations";

const rolesSvc = {
  createInstance,
  getOperations: operation.GET,
  getOperation: operationId.GET,
  addOperation: operation.POST,
  updateOperation: operationId.PUT,
  deleteOperation: operationId.DELETE,
  updateOperationSettings: setting.PUT,
  getUsers: user.GET,
  updateUsers: user.PUT,
  deleteUser: userId.DELETE,
  getCortevaUsers: corteva_user.GET,
  deleteCortevaUsers: corteva_user.DELETE,
  v4: {
    getOperation: operationV4.GET,
    getOperations: operationsV4.GET,
  },
  getOperationV4: operationV4.GET, // alias for v4.getOperation
};

export default rolesSvc;

export * from "./instance";
export * from "./schemas";
